/**
 * A flag pública. Nasce ligada: se o pedido ainda não voltou, ou se falhar,
 * a interface não mostra um mercado vazio. Quando o servidor diz que está
 * desligada, o mercado volta.
 */
import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';

const ModoRecrutamentoContext = createContext({ activo: true, pronto: false });

export function ModoRecrutamentoProvider({ children }) {
  const [estado, setEstado] = useState({ activo: true, pronto: false });

  useEffect(() => {
    let vivo = true;
    const ler = () => {
      api.get('/config')
        .then((r) => {
          if (!vivo) return;
          setEstado({ activo: r.data?.recruitment_mode !== false, pronto: true });
        })
        .catch(() => {
          if (vivo) setEstado({ activo: true, pronto: true });
        });
    };
    const aoVoltar = () => {
      if (document.visibilityState === 'visible') ler();
    };
    // Um 403 recruitment_mode chega de uma acção, não do ecrã. Sem isto
    // o separador continuava a mostrar o mercado até à próxima carga.
    const aoRecusar = () => {
      if (vivo) setEstado({ activo: true, pronto: true });
    };
    ler();
    document.addEventListener('visibilitychange', aoVoltar);
    window.addEventListener('dozy:recruitment-mode', aoRecusar);
    return () => {
      vivo = false;
      document.removeEventListener('visibilitychange', aoVoltar);
      window.removeEventListener('dozy:recruitment-mode', aoRecusar);
    };
  }, []);

  return (
    <ModoRecrutamentoContext.Provider value={estado}>
      {children}
    </ModoRecrutamentoContext.Provider>
  );
}

export function useModoRecrutamento() {
  return useContext(ModoRecrutamentoContext);
}
